import React from "react";

import { ProductValues } from "types/enums";

import { ReactComponent as NailSoftIcon } from "static/images/nail_soft_icon.svg";
import styles from "./tableColumns.module.scss";

const nailSoftColumn = ({ accessor = "is_nail_soft" } = {}) => ({
	Header: "",
	accessor,
	disableSortBy: true,
	classNameCell: styles.nailSoftColumn,
	classNameHeader: styles.nailSoftColumn,
	isSticky: true,
	Cell: ({ cell, row }) => {
		const isProductNailSoft =
			ProductValues.NailSoft.name === row.original?.product;
		const is_nail_soft = isProductNailSoft || cell?.value;
		return (
			<>
				{is_nail_soft && (
					<div className={styles.nailSoftContainer}>
						<NailSoftIcon width="16px" height="16px" />
					</div>
				)}
			</>
		);
	},
});

export default nailSoftColumn;
